import { render, staticRenderFns } from "./downMeal.vue?vue&type=template&id=05e39375&scoped=true&"
import script from "./downMeal.vue?vue&type=script&lang=js&"
export * from "./downMeal.vue?vue&type=script&lang=js&"
import style0 from "./downMeal.vue?vue&type=style&index=0&id=05e39375&lang=less&scoped=true&"
import style1 from "./downMeal.vue?vue&type=style&index=1&id=05e39375&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e39375",
  null
  
)

export default component.exports